import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface CustomDatePickerProps {
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  placeholderText?: string;
  dateFormat?: string;
  showTimeSelect?: boolean;
  timeFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  isClearable?: boolean;
}

const MonthDatePicker: React.FC<CustomDatePickerProps> = ({
  selectedDate,
  onChange,
  disabled,
  placeholderText = "Select date",
  showTimeSelect = false,
  timeFormat = "HH:mm",
  minDate,
  maxDate,
  isClearable = false,
}) => {
  return (
    <DatePicker
      selected={selectedDate}
      onChange={onChange}
      placeholderText={placeholderText}
      dateFormat='MM/yyyy'
      showMonthYearPicker
      showTimeSelect={showTimeSelect}
      timeFormat={timeFormat}
      minDate={minDate}
      disabled={disabled}
      maxDate={maxDate}
      isClearable={isClearable}
      className='custom-datepicker shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
    />
  );
};

export default MonthDatePicker;
